<div class="calendar">
    <div class="calendar__header">
        <button class="buttons button__prev" (click)="prevMonth()">
            <img src="./assets/icons/navigation/chevron-right-compact.svg" alt="prev" />
        </button>
        <span class="calendar__date">
            {{ formatMonth() }}
        </span>
        <button class="buttons button__next" (click)="nextMonth()">
            <img src="./assets/icons/navigation/chevron-right-compact.svg" alt="next" />
        </button>
    </div>

    <div class="calendar__grid">
        <div class="weekdays">
            <div *ngFor="let day of weekDays">
                {{ day }}
            </div>
        </div>

        <div class="weeks">
            <div class="week" *ngFor="let week of weeks">
                <div
                    *ngFor="let day of week"
                    class="day"
                    [class.active]="isActiveDate(day)"
                    [class.selected]="selectedDate?.hasSame(day, 'day')"
                    [class.other-month]="!day.hasSame(currentMonth, 'month')"
                    (click)="selectDate(day)"
                >
                    {{ day.day }}
                </div>
            </div>
        </div>
    </div>
</div>
